const GeneralData = {
  publicKey: process.env.REACT_APP_PUBLIC_KEY,
  host_api: process.env.REACT_APP_URL_API,
  domain: process.env.REACT_APP_URL_DOMAIN,
  host: process.env.REACT_APP_HOST_SITE,
  from: process.env.REACT_APP_EMAIL_USER_FROM,
  politictUpdatedAt: process.env.REACT_APP_POLITIC_UPDATE_AT,
  omniaGatewayKey: process.env.REACT_APP_OMNIA_GATEWAY_KEY,
};

module.exports = GeneralData;
